import { render, staticRenderFns } from "./InvoicesInboundTable.vue?vue&type=template&id=34e020e6&scoped=true"
import script from "./InvoicesInboundTable.vue?vue&type=script&lang=js"
export * from "./InvoicesInboundTable.vue?vue&type=script&lang=js"
import style0 from "./InvoicesInboundTable.vue?vue&type=style&index=0&id=34e020e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e020e6",
  null
  
)

export default component.exports